<template>
  <div class="balance-details-wrapper app-content-wrapper" v-loading="pageLoading">
    <!-- 非付款商户 -->
        <template v-if="`${app.userLogin.businessType}` !== '0' && businessType !== 'payout'">
      <div class="balance-currency-box">
        <el-image fit="scale-down" class="currency-img"
          :src="getCurrencyImage(balanceSummary.currency) ? require(`@/assets/images/currency/${balanceSummary.currency}.png`) : ''"></el-image>
        <div class="currency-name">{{ balanceSummary.currency }}</div>
      </div>
      <ul class="balance-summary-list">
        <template v-for="(item, index) in balanceArray">
          <li :key="index" class="balance-summary-item" :class="{ active: activeBalance === index }"
            @click="changeSummary(item, index)">
            <img class="icon" :src="activeBalance === index ? item.iconActive : item.icon" />
            <div class="summary-item-info">
              <p class="title">
                <span>{{ $t(item.label) }}</span>
                <el-popover v-if="item.tips" placement="right" :width="300" trigger="hover" :visible-arrow="false">
                  <div>{{ $t(item.tips) }}</div>
                  <template #reference>
                    <i class="margin-left-6 iconfont icon-tishi003"></i>
                  </template>
                </el-popover>
              </p>
              <p class="amount">{{ item.value || '0.00' }}</p>
            </div>
          </li>
        </template>
      </ul>
    </template>
    <!-- 付款商户 -->
    <template v-if="`${app.userLogin.businessType}` === '0' || businessType === 'payout'">
      <div class="balance-info">
        <div class="balance-info-left">
          <img class="currency-img"
            :src="getCurrencyImage(balanceSummary.currency) ? require(`@/assets/images/currency/${balanceSummary.currency}.png`) : ''" />
          <div class="currency-name">{{ balanceSummary.currency || '' }}</div>
          <div class="currency-name">{{ getCurrencyDesc(balanceSummary.currency) }}</div>
        </div>
        <div class="balance-info-right">
          <el-button v-permission="'wallet:balance:recharge'" v-if="showRechargeButton" size="small"
            @click="handleRecharge">{{ $t('message.wallet.recharge') }}</el-button>
          <!-- <el-button v-if="showOpenVaButton" size="small" @click="handleCreateVa">{{$t('message.wallet.openRechargeVa')}}</el-button> -->
          <el-button v-if="showTransferButton" size="small" type="primary"
            @click="handleTransfer">{{ $t('message.wallet.payout') }}</el-button>
        </div>
      </div>
      <div class="balance-summary-list">
        <div class="balance-summary-item" :class="{ active: activeB2bBalance === 0 }"
          @click="changeSummary({ code: 'AVAIL' }, 0)">
          <img class="icon"
            :src="activeB2bBalance === 0 ? require('@/assets/images/balance/icon-avail-active.png') : require('@/assets/images/balance/icon-avail.png')" />
          <div class="summary-item-info">
            <p class="title">{{ $t('message.settlement.availableBalanceAct') }}</p>
            <p class="amount">{{ balanceSummary.availBalance && balanceSummary.availBalance.amount ?
              balanceSummary.availBalance.amount : '0.00'}}</p>
          </div>
        </div>
        <div class="balance-summary-item" :class="{ active: activeB2bBalance === 1 }"
          @click="changeSummary({ code: 'FREEZE' }, 1)">
          <img class="icon"
            :src="activeB2bBalance === 1 ? require('@/assets/images/balance/icon-freeze-active.png') : require('@/assets/images/balance/icon-freeze.png')" />
          <div class="summary-item-info">
            <p class="title">{{ $t('message.settlement.frozenAct') }}</p>
            <p class="amount">{{ balanceSummary.freezeBalance && balanceSummary.freezeBalance.amount ?
              balanceSummary.freezeBalance.amount : '0.00'}}</p>
          </div>
        </div>
        <div class="balance-summary-item" :class="{ active: activeB2bBalance === 2 }"
          @click="changeSummary({ code: '' }, 2)">
          <img class="icon"
            :src="activeB2bBalance === 2 ? require('@/assets/images/balance/icon-total-active.png') : require('@/assets/images/balance/icon-total.png')" />
          <div class="summary-item-info">
            <p class="title">
              <span>{{ $t('message.settlement.accountTotalAmount') }}</span>
              <el-popover placement="right" :width="300" trigger="hover" :visible-arrow="false">
                <div>{{ $t('message.wallet.actAmountTips') }}</div>
                <template #reference>
                  <i class="margin-left-6 iconfont icon-tishi003"></i>
                </template>
              </el-popover>
            </p>
            <p class="amount">{{ balanceSummary.totalBalance && balanceSummary.totalBalance.amount ?
              balanceSummary.totalBalance.amount : '0.00'}}</p>
          </div>
        </div>
      </div>
    </template>
    <div class="search-wrapper" style="padding-top: 20px;">
      <search-component ref="search" :search-condition="searchCondition" :search-buttons="searchButtonList"
        :is-judgment-time="true" :fuzzy-search-key="'serviceId'" :fuzzySearchPlaceholder="fuzzySearchPlaceholder"
        :excludeParamsLength="['acntId']" router-name="/wallet/balance/view">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition" :service-function="getAccountFlow" ref="table"
        :is-first-automatic-visit="false" router-name="/wallet/balance/view"
        @serviceFunStartCallback="serviceFunStartCallback" :additional-parameters="getAdditionalParameters()"
        @serviceFunEndCallback="serviceFunEndCallback">
      </custom-table>
    </div>
    <RechargeModal ref="balanceRechargeModal"></RechargeModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { ShowSuccessMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getCurrencyImage } from '@/utils/tools/currency';
import { getTodayParams, initToday } from '@/utils/tools/time';
import { checkPermission } from '@/views/index/api/index';
import RechargeModal from '@/views/index/recharge.vue';
import BalancesService from '@/views/settlement/api/settlement-balance';
import { QueryHistoryOptions } from '@/views/transaction/status/transaction';
import WalletBalanceService from '@/views/wallet/api/balance';

export default {
  components: {
    SearchComponent,
    CustomTable,
    RechargeModal,
  },
  data() {
    return {
      pageLoading: false,
      getTodayParams,
      balanceSummary: {},
      balanceArray: [],
      activeBalance: 0,
      activeB2bBalance: 0,
      acntId: this.$route.query.acntId,
      fuzzySearchPlaceholder: `${this.$t('message.transfer.transactionNumber')}`,
      searchCondition: [
        {
          key: 'acntId',
          name: 'message.transfer.transactionNumber',
          type: 'input',
          isHide: true,
          defValue: this.$route.query.acntId,
        },
        {
          key: 'currency',
          name: 'message.transfer.transactionNumber',
          type: 'input',
          isHide: true,
          defValue: this.$route.query.currency,
        },
        {
          key: 'subAcntType',
          name: 'message.transfer.transactionNumber',
          type: 'input',
          isHide: true,
          defValue: 'AVAIL',
        },
        {
          key: ['beginTime', 'endTime'],
          name: 'message.wallet.time',
          defValue: initToday(),
          type: 'date_time',
          required: true,
        },
        {
          key: 'isHistory',
          name: 'message.tableCommon.queryHistory',
          type: 'select',
          defValue: '',
          options: QueryHistoryOptions,
          isInternationalization: true,
        },
        {
          key: 'txnType',
          name: 'message.tableCommon.txnType',
          type: 'select',
          defValue: '',
          options: [],
        },
      ],
      downloading: false,
      searchButtonList: [
        {
          type: 'download',
          permissionCode: 'wallet:balance:view:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await this.downloadAccountFlow(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        },
      ],
      tableCondition: [
        { // 时间
          titleBar: { type: 'text', title: 'message.wallet.time' },
          key: 'balanceUpdDate',
          type: 'text',
        },
        { // 流水号
          key: 'serviceId',
          titleBar: { title: 'message.transfer.transactionNumber', type: 'text' },
          type: 'text',
        },
        { // 交易类型
          key: 'txnType',
          titleBar: { title: 'message.tableCommon.txnType', type: 'text' },
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.txnTypeAllList, row.txnType),
        },
        { // 子账户类型
          titleBar: { type: 'text', title: 'message.wallet.subAccountType' },
          key: 'subAcntType',
          type: 'text',
          textFunc: (row) => this.$t(getEnantiomericValue(this.subAcntTypeListItems, row.subAcntType)),
        },
        { // 币种
          titleBar: { type: 'text', title: 'message.tableCommon.currency' },
          key: 'currency',
          type: 'text',
        },
        { // 期初金额
          titleBar: { type: 'text', title: 'message.wallet.openingAmount' },
          key: 'accountBalanceBefore',
          type: 'text',
        },
        { // 动账金额
          titleBar: { type: 'text', title: 'message.wallet.movingAmount' },
          key: 'moveAmount',
          type: 'text',
        },
        { // 期末金额
          titleBar: { type: 'text', title: 'message.wallet.closingAmount' },
          key: 'accountBalanceAfter',
          type: 'text',
          itemWidth: '210px',
        },
        { // 备注
          titleBar: { type: 'text', title: 'message.tableCommon.remark' },
          key: 'remark',
          type: 'text',
        },
      ],
      txnTypeList: [],
      subAcntTypeList: [],
      subAcntTypeListItems: [
        { value: 'AVAIL', label: 'message.settlement.availableBalance' },
        { value: 'UNSETTLE', label: 'message.settlement.pendingSettledAmount' },
        { value: 'FREEZE', label: 'message.settlement.frozenAmount' },
        { value: 'DEPOSIT', label: 'message.settlement.marginAmount' },
        { value: '', label: 'message.settlement.accountTotalAmount' },
      ],
      showTransferButton: false,
      showRechargeButton: false,
      showOpenVaButton: false,
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      if (this.$route.query.businessType) {
        if (this.$route.query.businessType === 'payout' || this.$route.query.businessType === 'PAYOUT') {
          return 'payout';
        } else if (this.$route.query.businessType === 'acq' || this.$route.query.businessType === 'ACQUIRING') {
          return 'acq';
        }
      }
      return '';
    },
  },
  watch: {
    $route: {
      handler() {
        const subAcntType = this.$route.query.subAcntType;
        this.activeBalance = ['AVAIL', 'UNSETTLE', 'FREEZE', 'DEPOSIT'].indexOf(subAcntType);
        if (this.activeBalance < 0) {
          this.activeBalance = 4;
        }

        if (this.app.userLogin.businessType === '0' || this.businessType === 'payout') { // 付款商户
          const subAcntType = this.$route.query.subAcntType;
          this.activeB2bBalance = ['AVAIL', 'FREEZE'].indexOf(subAcntType);
          if (this.activeB2bBalance < 0) {
            this.activeB2bBalance = 2;
          }
        }
      },
    },
  },
  mounted() {
    if (this.acntId) {
      this.httpGetAccountBalances();
    }
    const subAcntType = this.$route.query.subAcntType;
    this.activeBalance = ['AVAIL', 'UNSETTLE', 'FREEZE', 'DEPOSIT'].indexOf(subAcntType);
    if (this.activeBalance < 0) {
      this.activeBalance = 4;
    }

    if (this.app.userLogin.businessType === '0' || this.businessType === 'payout') { // 付款商户
      const subAcntType = this.$route.query.subAcntType;
      this.activeB2bBalance = ['AVAIL', 'FREEZE'].indexOf(subAcntType);
      if (this.activeB2bBalance < 0) {
        this.activeB2bBalance = 2;
      }
    }

    this.checkButtonPermission();

    this.initMethod();
  },
  methods: {
    async checkButtonPermission() {
      try {
        const currency = this.$route.query.currency;
        // 当币种不是 USD、GBP、EUR时，隐藏充值按钮
        if (['USD', 'GBP', 'EUR', 'CNH', 'HKD'].includes(currency)) {
          this.showRechargeButton = true;
          checkPermission('transfer:transfer:add').then((res) => {
            this.showTransferButton = res;
          });
        }
      } catch (err) {

      }
    },
    async initMethod() {
      await GlobalData.getDictList(['SUB_ACNT_TYPE', 'TXN_TYPE_ACCOUNT']).then((res) => {
        if (this.app.userLogin.businessType === '0' || this.businessType === 'payout') {
          // 费用调整、充值、提现、付款、提现/付款手续费、月费、入账手续费、入账冻结、入账扣除
          const arr = ['0036', '0043', '0049', '0034', '0032', '0041', '0035', '0047', '0048', '0037'];
          this.txnTypeList = initSelectedData(res.TXN_TYPE_ACCOUNT.filter(item => (arr.indexOf(item.value) > -1)));
        } else {
          this.txnTypeList = initSelectedData(res.TXN_TYPE_ACCOUNT);
        }
        this.subAcntTypeList = initSelectedData(res.SUB_ACNT_TYPE);
        this.txnTypeAllList = initSelectedData(res.TXN_TYPE_ACCOUNT);
        if (this.$refs.search) {
          this.$refs.search.setSearchSelectOptions('txnType', this.txnTypeList);
        }
      }).catch(() => {
      });
      this.$refs.table.firstVisitHttp();
    },
    httpGetAccountBalances() {
      const params = {
        businessType: this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null,
      };
      BalancesService.getAccountBalances(params).then(res => {
        if (res && res.length) {
          for (let i = 0; i < res.length; i++) {
            if (this.acntId === res[i].acntId) {
              this.balanceSummary = res[i];
              this.balanceArray = this.getBalanceArray(res[i]);
              break;
            }
          }
        }
      });
    },
    getBalanceArray(data) {
      this.defaultParameters = { acntId: data.acntId };
      return [
        {
          type: 'availableBalance',
          code: 'AVAIL',
          label: 'message.settlement.availableBalance',
          value: data.availBalance && data.availBalance.amount,
          icon: require('@/assets/images/balance/icon-avail.png'),
          iconActive: require('@/assets/images/balance/icon-avail-active.png'),
        },
        {
          type: 'pendingSettledAmount',
          code: 'UNSETTLE',
          label: 'message.settlement.pendingSettledAmount',
          value: data.unsettleBalance && data.unsettleBalance.amount,
          icon: require('@/assets/images/balance/icon-unsettle.png'),
          iconActive: require('@/assets/images/balance/icon-unsettle-active.png'),
        },
        {
          type: 'frozenAmount',
          code: 'FREEZE',
          label: 'message.settlement.frozenAmount',
          value: data.freezeBalance && data.freezeBalance.amount,
          icon: require('@/assets/images/balance/icon-freeze.png'),
          iconActive: require('@/assets/images/balance/icon-freeze-active.png'),
        },
        {
          type: 'marginAmount',
          code: 'DEPOSIT',
          label: 'message.settlement.marginAmount',
          value: data.depositBalance && data.depositBalance.amount,
          icon: require('@/assets/images/balance/icon-deposit.png'),
          iconActive: require('@/assets/images/balance/icon-deposit-active.png'),
        },
        {
          type: 'accountTotalAmount',
          code: '',
          label: 'message.settlement.accountTotalAmount',
          value: data.totalBalance && data.totalBalance.amount,
          icon: require('@/assets/images/balance/icon-total.png'),
          iconActive: require('@/assets/images/balance/icon-total-active.png'),
          tips: 'message.wallet.actAmountTips',
        },
      ];
    },
    changeSummary(item, index) {
      const query = this.$refs.search.getSearchJson();
      if (query.subAcntType === item.code) {
        return;
      }
      if (!query.beginTime) {
        ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.wallet.time') }));
        return;
      }
      if (!query.endTime) {
        ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.wallet.time') }));
        return;
      }
      query.subAcntType = item.code;
      query.businessType = this.businessType ? (this.businessType) : null;
      console.log('query', query);
      this.$refs.search.sendQueryCriteria(query);
      this.activeBalance = index;
      this.activeB2bBalance = index;
    },
    serviceFunStartCallback() {
      this.pageLoading = true;
    },
    serviceFunEndCallback() {
      this.pageLoading = false;
    },
    handleTransfer() {
      const businessTypes = this.businessType ? (this.businessType === 'payout' || this.businessType === 'PAYOUT' ? 'payout' : 'acq') : null;
      this.$router.push({ path: '/transfer/transfer/add/recipient', query: { currency: this.balanceSummary.currency, businessType: businessTypes } });
    },
    handleRecharge() {
      if (`${this.app.userLogin.merchantStatus}` === '4') { // 未启用时，弹出提示
        this.$bus.$emit('showAuditStatusAlert');
        return;
      }
      // if (this.balanceSummary.currency !== 'USD') {
      //   ShowErrorMessage(this.$t('message.wallet.rechargeTips', { currency: this.balanceSummary.currency }));
      //   return;
      // }
      // this.$router.push({ path: '/collection/virtual-account/recharge', query: { currency: this.balanceSummary.currency } });
      this.$refs.balanceRechargeModal.openModal(this.balanceSummary.currency);
    },
    handleCreateVa() {
      if (`${this.app.userLogin.merchantStatus}` === '4') { // 未启用时，弹出提示
        this.$bus.$emit('showAuditStatusAlert');
        return;
      }
      this.$router.push('/collection/virtual-account/add');
    },
    getAdditionalParameters() {
      let businessType = null;
      if (this.businessType && (this.businessType === 'payout' || this.businessType === 'PAYOUT')) {
        businessType = 'PAYOUT';
      } else if (this.businessType && (this.businessType === 'acq' || this.businessType === 'ACQUIRING')) {
        businessType = 'ACQUIRING';
      }
      console.log(businessType, 'businessTypeguan');
      return {
        businessType,
      };
    },
    getCurrencyDesc(currency) {
      if (!currency) {
        return '';
      }
      const desc = this.$t(`message.currencyDesc.${currency}`);
      if (!desc || desc.indexOf('message') > -1) {
        return '';
      }
      return desc;
    },
    getCurrencyImage,
    ...WalletBalanceService,
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.balance-details-wrapper {
  padding-top: 13px;

  .balance-currency-box {
    display: flex;
    align-items: center;
  }

  .currency-img {
    width: 26px;
  }

  .currency-name {
    font-size: 23px;
    line-height: 31px;
    font-weight: 800;
    display: inline-block;
    vertical-align: top;
    margin-left: 14px;
  }

  .summary-list {
    display: flex;
    align-items: flex-end;
    margin-top: 14px;
    padding-bottom: 25px;
    border-bottom: 1px solid rgba(0, 32, 63, 0.08);

    .summary-item {
      // width: 200px;
      flex: 1;
      height: 70px;
      padding: 12px 16px 0px;
      box-sizing: border-box;
      background: $color-default;
      border-radius: 8px;
      margin-right: 15px;
      position: relative;
      overflow: hidden;

      &::after {
        content: '';
        width: 0px;
        height: 100%;
        background-color: rgba(0, 148, 198, 0.2);
        position: absolute;
        top: 0;
        left: 0;
        transition: width 0.3s;
        border-width: 0;
      }

      &:hover {
        &::after {
          width: 8px;
        }
      }

      &.active {
        &::after {
          width: 8px;
          background-color: $color-text-default-button;
        }
      }

      &:first-child {
        padding-top: 20px;
        height: 103px;

        // background: $color-text-default-button;
        // color: $color-white;
        .top-wrapper {
          display: flex;
          align-items: center;
        }

        .value {
          margin-top: 12px;
        }
      }

      &:last-child {
        margin-right: 0px;
        text-align: right;
        // background: transparent;
      }

      .top-wrapper {
        .name {
          font-size: 14px;
          font-weight: normal;
          line-height: 19px;
        }

        .iconfont {
          font-size: 12px;
          margin-left: 10px;
          // display: none;

          &.icon-wenhao {
            cursor: pointer;
          }
        }
      }

      .value {
        font-size: 30px;
        font-weight: 800;
        line-height: 41px;
        margin-top: 4px;
      }
    }
  }

  .balance-currency {
    font-size: 14px;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 20px;
  }

  .balance-info {
    display: flex;
    justify-content: space-between;

    .balance-info-left {
      display: flex;
      align-items: center;

      .currency-img {
        width: 26px;
      }

      .currency-name {
        font-size: 23px;
        line-height: 31px;
        margin-left: 10px;
      }

      .balance-amount {
        font-size: 30px;
        font-family: Avenir-Heavy, Avenir;
        font-weight: 800;
        color: $color-text-primary;
        line-height: 41px;
      }
    }

    .balance-info-right {
      button {
        min-width: 120px;
      }
    }
  }

  .balance-summary-list {
    display: flex;
    align-items: center;
    margin-bottom: 11px;
    margin-top: 25px;

    .balance-summary-item {
      display: flex;
      align-items: center;
      // min-width: 260px;
      flex: 1;
      height: 70px;
      background: #F4F6F8;
      border-radius: 8px;
      margin-right: 10px;
      cursor: pointer;
      padding-left: 14px;

      &.active {
        background: #EEF9FF;
      }

      .iconfont {
        font-size: 38px;
      }

      .icon {
        width: 38px;
        height: 38px;
      }

      .summary-item-info {
        margin-left: 10px;

        .title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: $color-text-primary;
          line-height: 20px;
          margin-bottom: 2px;
        }

        .amount {
          font-size: 18px;
          font-family: Avenir-Heavy, Avenir;
          font-weight: 800;
          color: $color-text-primary;
          line-height: 25px;
        }

        .iconfont {
          color: rgba(38, 67, 115, 0.6);
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
